import { create } from 'zustand'

/** サーバが導出する在席状態 (backend/src/services/presenceState.ts と対) */
export type PresenceState = 'available' | 'busy' | 'away' | 'impaired'

export interface Operator {
  userId: string
  userName?: string
  displayName?: string
  name?: string
  email?: string
  avatar?: string
  role?: string
  status?: string
  available?: boolean
  presenceState?: PresenceState
  lastSeen?: number
  expiresAt?: number
}

/**
 * 表示用の在席状態を決める boundary normalizer。
 * presenceState を持たない行 (presenceState 導入前のサーバ/クライアントの
 * 残存データ) は、旧仕様の available (=着信音ミュートでない) から
 * available/away に写像する。優先順位はこの一箇所にのみ書く。
 */
export function presenceStateOf(op: Operator): PresenceState {
  if (op.presenceState) return op.presenceState
  return op.available ? 'available' : 'away'
}

interface PresenceStore {
  activeOperators: Operator[]
  setActiveOperators: (items: Operator[]) => void
}

export const usePresenceStore = create<PresenceStore>((set) => ({
  activeOperators: [],
  setActiveOperators: (items) => set({ activeOperators: items || [] }),
}))
